import { hasPermission } from "../../helpers/helpers"
import React, { useEffect, useState } from "react"
import { withRouter, Link } from "react-router-dom"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, {
  CSVExport,
  Search,
} from "react-bootstrap-table2-toolkit"

import { Button, Card, CardBody, Col, Row } from "reactstrap"
import axios from "axios"
import { API_URL } from "../../constants/constants"
import moment from "moment"
import { FiltersCard } from "./filter"
import ReactHTMLTableToExcel from "react-html-table-to-excel"
import TableLoader from "components/Common/TableLoader"

//redux

const TabFive = props => {
  const selectRow = {
    mode: "checkbox",
  }

  const [data, setData] = useState([])
  const [fromDate, setFromDate] = useState(moment().format("YYYY-MM-DD"))
  const [toDate, setToDate] = useState(moment().format("YYYY-MM-DD"))
  const [tab, setTab] = useState(5)
  const [loading, setLoading] = useState(false)
  const { SearchBar } = Search

  const call = () => {
    setLoading(true);
    axios({
      method: "GET",
      url: `${API_URL}/admin/risk-per-user/${tab}?from=${fromDate}`,
    })
      .then(function (response) {
        const rawData = response?.data?.data || [];
        const formattedData = rawData.map((item) => ({
          ...item,
          date_of_joining: item?.created_at
            ? new Date(item.created_at).toLocaleString("en-GB", {
                timeZone: "CAT",
                hour12: true,
              })
            : "-",
          last_login: item?.logins?.created_at
            ? new Date(item.logins.created_at).toLocaleString("en-GB", {
                timeZone: "CAT",
                hour12: true,
              })
            : "-",
          last_transaction: item?.last_transaction
            ? new Date(item.last_transaction).toLocaleString("en-GB", {
                timeZone: "CAT",
                hour12: true,
              })
            : "-",
        }));
        setData(formattedData);
        setLoading(false);
      })
      .catch(function (response) {
        setLoading(false);
      });
  };
  

  useEffect(() => {
    setLoading(true)
    call()
  }, [tab])

  const dataColumn = [
    {
      dataField: "id",
      text: "Customer ID",
      sort: true,
    },
    {
      dataField: "phone_number",
      text: "Phone Number",
      sort: true,
    },
    {
      dataField: "date_of_joining", // Unique dataField for "Date Of Joining"
      text: "Date Of Joining",
      formatter: (cell, row) => {
        const date = new Date(row?.created_at); // Access top-level created_at
        const formattedDate = date.toLocaleString("en-GB", {
          timeZone: "CAT",
          hour12: true,
        });
        const capitalizedDate = formattedDate.replace(/(am|pm)/gi, (match) =>
          match.toUpperCase()
        );
        return <>{capitalizedDate}</>;
      },
      sort: true,
    },
    {
      dataField: "last_login", // Unique dataField for "Last Login"
      text: "Last Login",
      formatter: (cell, row) =>
        row?.logins?.created_at ? (
          <>
            {new Date(row.logins.created_at).toLocaleDateString("en-GB", {
              timeZone: "CAT",
            })}{" "}
            {new Date(row.logins.created_at).toLocaleTimeString("en-GB", {
              timeZone: "CAT",
            })}
          </>
        ) : (
          "-"
        ),
      sort: true,
    },
    {
      dataField: "last_transaction",
      text: "Last Transaction",
      formatter: (cell, row) =>
        row?.last_transaction ? ( // Access top-level last_transaction
          <>
            {new Date(row.last_transaction).toLocaleDateString("en-GB", {
              timeZone: "CAT",
            })}{" "}
            {new Date(row.last_transaction).toLocaleTimeString("en-GB", {
              timeZone: "CAT",
            })}
          </>
        ) : (
          "-"
        ),
      sort: true,
    },
    {
      dataField: "cash_balance",
      text: "Cash Balance",
      sort: true,
    },
  ];
  

  const { ExportCSVButton } = CSVExport
  const defaultSorted = [
    {
      dataField: "id",
      order: "desc",
    },
  ]

  //pagination customization
  const pageOptions = {
    sizePerPage: 30,
    totalSize: data?.length,
    custom: true,
  }

  return (
    <React.Fragment>
      <FiltersCard
        toDate={toDate}
        fromDate={fromDate}
        setFromDate={d => setFromDate(d)}
        setToDate={d => setToDate(d)}
        call={() => {
          call()
        }}
        hideShowType={false}
      />
      <Card>
        <CardBody>
          <div className="mb-4 h4 card-title">
            {"Customers who have NOT logged in for more than 1 month ago."}
          </div>
          {loading ? (
            <TableLoader />
          ) : (
            <PaginationProvider
              pagination={paginationFactory(pageOptions)}
              keyField="id"
              columns={dataColumn}
              data={data}
            >
              {({ paginationProps, paginationTableProps }) => (
                <ToolkitProvider
                  keyField="id"
                  data={data}
                  columns={dataColumn}
                  bootstrap4
                  search
                  exportCSV={{
                    onlyExportFiltered: true,
                    exportAll: false,
                    fileName: `Fifth-Report-${moment(new Date()).format(
                      "DD/MM/YYYY"
                    )}.csv`,
                  }}
                >
                  {toolkitProps => (
                    <React.Fragment>
                      <Row className="mb-2">
                        <Col sm="6">
                          <Row>
                            <Col sm="12">
                              <div className="search-box me-2 mb-2 d-inline-block">
                                <div className="position-relative">
                                  <SearchBar {...toolkitProps.searchProps} />
                                  <i className="bx bx-search-alt search-icon" />
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </Col>
                        <Col sm="6">
                          <div>
                            <ExportCSVButton
                              {...toolkitProps.csvProps}
                              className="download-table-xls-button w-md btn btn-primary"
                            >
                              Download
                            </ExportCSVButton>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col xl="12">
                          <div className="table-responsive">
                            <BootstrapTable
                              keyField="id"
                              responsive
                              bordered={false}
                              striped={false}
                              defaultSorted={defaultSorted}
                              selectRow={selectRow}
                              classes={
                                "table align-middle table-nowrap table-check"
                              }
                              headerWrapperClasses={"table-light"}
                              {...toolkitProps.baseProps}
                              {...paginationTableProps}
                              rowClasses={"mytable-hover-row"}
                            />
                          </div>
                        </Col>
                      </Row>
                      <div className="pagination pagination-rounded justify-content-end">
                        <PaginationListStandalone {...paginationProps} />
                      </div>
                    </React.Fragment>
                  )}
                </ToolkitProvider>
              )}
            </PaginationProvider>
          )}
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default withRouter(TabFive)
